// Module
var code = "<div class=\"fg-edit-canvas-area\" ng-class=\"{ 'hide': hideDropArea(), 'dragging':showDragArea() }\" dq-drop=\"canvasCtrl.drop({{$index === undefined ? 0 : $index + 1}})\"> Drop here </div> ";
// Exports
export default code;